import type { Enemy } from '../Enemy';
import type { MovementBehavior } from './MovementBehavior';
import { getEnemyMobileSpeedMultiplier } from '../../constants/scale';

export class ChaseBehavior implements MovementBehavior {
  init(): void {
    // Без состояния
  }

  update(enemy: Enemy, deltaMs: number, target: { x: number; y: number }): void {
    const dx = target.x - enemy.x;
    const dy = target.y - enemy.y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    if (dist < 1) return;

    let effectiveSpeed = enemy.config.speed;
    const hpMul = enemy.config.speedHpMultiplier;
    if (hpMul && enemy.maxHp > 1) {
      const hpRatio = enemy.currentHp / enemy.maxHp;
      const lostRatio = 1 - hpRatio;
      effectiveSpeed = enemy.config.speed * (1 + lostRatio * hpMul);
    }
    effectiveSpeed *= getEnemyMobileSpeedMultiplier();

    const moveDistance = (effectiveSpeed * deltaMs) / 1000;
    enemy.x += (dx / dist) * moveDistance;
    enemy.y += (dy / dist) * moveDistance;
  }
}
